/**
 * Layout Engine component
 */
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  ChangeDetectorRef,
  OnDestroy, AfterViewInit, ElementRef, Renderer2
} from '@angular/core';
import { LayoutEngineService } from '@ispm-client/modules/layout-engine/services/layout-engine.service';
import {Observable, Subject, Subscription} from 'rxjs';
import { takeUntil, filter } from "rxjs/operators";
import { CoreActionCreatorService } from "@ispm/core/services/core-action-creator.service";
import { get, isEmpty } from "lodash";
import {cloneDeep} from 'lodash';
import { ActivatedRoute, Router } from "@angular/router";
import { ILayoutConfigParams } from "@ispm-client/modules/layout-engine/interfaces/layout-config-params.interface";

@Component({
  selector: 'ispm-layout-engine',
  templateUrl: './layout-engine.component.html',
  styleUrls: ['./layout-engine.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LayoutEngineComponent implements OnInit, OnDestroy, AfterViewInit {
  layoutEngineParams: ILayoutConfigParams;
  eventSubscription: Subscription;
  private routeDataSubscription: Subscription;
  @Input() config: any;
  @Input() set params(params: Observable<any>) {
    if (params){
      this.eventSubscription = params
        .pipe(
          takeUntil(this.destroyer.asObservable()),
          filter(layoutParams => !!layoutParams)
        )
        .subscribe(layoutParams => {
          this.layoutEngineParams = layoutParams;
          this.loadLayoutEngineConfig();
        });
    }
  };
  @Input() disabled?: boolean = false;
  @Input() editMode?: boolean;
  private destroyer: Subject<any> = new Subject();
  @Input() isScrollable: boolean;

  constructor(private _layoutEngineService: LayoutEngineService,
              private changeDetector: ChangeDetectorRef,
              private coreActionCreatorService: CoreActionCreatorService,
              private activatedRoute: ActivatedRoute,
              private renderer: Renderer2,
              private elementRef: ElementRef,
              private _router: Router
  ) {
  }

  ngOnInit() {
    this.routeDataSubscription = this.activatedRoute.data
    .pipe(filter((data) => !!data))
    .subscribe(data => {
      this.layoutEngineParams = data['layoutParams'] ?? {};
      this.loadLayoutEngineConfig();
    });
  }

  trackByFunction(index: number, widget: any){
    return `${widget.width}_${widget.$$ || ''}`;
  }

  private loadLayoutEngineConfig() {
    if (this.layoutEngineParams && Object.keys(this.layoutEngineParams).length > 0) {
      this.isScrollable = get(this.layoutEngineParams,'isScrollable',false);
      this._layoutEngineService.getLayoutConfig(this.layoutEngineParams).pipe(takeUntil(this.destroyer.asObservable())).subscribe(data => {
          if (this.editMode != undefined) {
            for (let widgets of data as Array<{ 'items': [{ 'widgetPayload': { 'editMode': boolean } }] }>) {
              if (widgets != undefined && widgets.items != undefined) {

                for (let widgetItem of widgets.items) {
                  if (widgetItem.widgetPayload) {
                    widgetItem.widgetPayload.editMode = this.editMode;
                  }
                }

              }
            }
          }
          this.config =  cloneDeep(data);
          this.changeDetector.markForCheck();
          this.changeDetector.detectChanges();
          if ((data as Array<any>).length > 0 && data[0]?.overflow) {
            const hostElement = this.elementRef.nativeElement;
            this.renderer.setStyle(hostElement, 'overflow', data[0].overflow);
          }
        });
        this.coreActionCreatorService.setLoader(false);
    }
  }

  ngAfterViewInit(): void {
    if (!this.layoutEngineParams) {
      this.coreActionCreatorService.setLoader(false);
    }
  }

  ngOnDestroy(): void {
    if (this.eventSubscription){
      this.eventSubscription.unsubscribe();
    }
    if (this.routeDataSubscription) {
      this.routeDataSubscription.unsubscribe();
    }
    this.config = null;
    this.destroyer.next();
    this.destroyer.complete();
  }
}
